export default __webpack_public_path__ + "static/media/gallery_01.b2491dd7.jpg";